import { MetaReducer } from '@ngrx/store';
import { hydrationMetaReducer } from './redux-hydration';

export const metaReducers: MetaReducer[] = [hydrationMetaReducer];
